var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
/* tslint:disable: class-name */
/*
 * AUTOGENERATED FILE - DO NOT EDIT
 */
import { ewJSONPortalAgreement } from './ewJSONPortalAgreement';
import { ewJSONPortalTrackingSetup } from './ewJSONPortalTrackingSetup';
import { JSONStruct, array_property, nullable, property } from 'badphraim/data/JSONStruct';
export class ewJSONPortal extends JSONStruct {
    constructor() {
        super(...arguments);
        /** @override */ this.id = 0;
        /** @override */ this.link_to_tos = [];
        /** @override */ this.show_timetable = false;
    }
}
__decorate([
    nullable,
    __metadata("design:type", String)
], ewJSONPortal.prototype, "address", void 0);
__decorate([
    nullable,
    __metadata("design:type", String)
], ewJSONPortal.prototype, "contact_email", void 0);
__decorate([
    property,
    __metadata("design:type", Number)
], ewJSONPortal.prototype, "id", void 0);
__decorate([
    array_property(ewJSONPortalAgreement),
    __metadata("design:type", Array)
], ewJSONPortal.prototype, "link_to_tos", void 0);
__decorate([
    nullable,
    __metadata("design:type", Number)
], ewJSONPortal.prototype, "minimum_age", void 0);
__decorate([
    nullable,
    __metadata("design:type", Number)
], ewJSONPortal.prototype, "short_term_minimum_age", void 0);
__decorate([
    property,
    __metadata("design:type", Boolean)
], ewJSONPortal.prototype, "show_timetable", void 0);
__decorate([
    nullable,
    __metadata("design:type", String)
], ewJSONPortal.prototype, "title", void 0);
__decorate([
    nullable,
    __metadata("design:type", ewJSONPortalTrackingSetup)
], ewJSONPortal.prototype, "tracking", void 0);
__decorate([
    nullable,
    __metadata("design:type", Boolean)
], ewJSONPortal.prototype, "use_direct_payment", void 0);
